// PartA6SkillsForLife.js - Page 2: Skills for Life
import React from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

const PartA6SkillsForLife = ({ formData, handleInputChange }) => {
    return (
        <div className="a4-page font-[poppins] bg-white p-8 mx-auto text-[#333333]" style={{ maxWidth: '100%', width: '100%' }}>
            {/* Header */}
            <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-[#F97316] mb-1">PART A (6)</h2>
                <h3 className="text-lg font-bold text-black">Skills for Life</h3>
            </div>

            {/* Introduction Text */}
            <div className="mb-8 text-sm leading-relaxed text-justify bg-orange-50 p-4 rounded-lg border border-orange-100">
                <p>
                    We develop lots of important skills in our school years. Some of them are useful in school, but
                    some of them are "life skills" that will be important to us in the future, no matter what we do.
                    Think about one important life skill that you have gained and fill out the boxes below.
                </p>
            </div>

            {/* Skills Reflection Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {/* Top Row - Two Columns */}
                <div className="bg-[#EFF6FF] rounded-lg overflow-hidden border border-blue-200 flex flex-col h-full">
                    <div className="bg-[#BFDBFE] p-3 text-center font-bold text-sm border-b border-blue-200">
                        One important life skill you have learned at home, school or in the community
                    </div>
                    <div className="p-0 flex-1">
                        <TextArea
                            value={formData.important_life_skill}
                            onChange={(e) => handleInputChange('important_life_skill', e.target.value)}
                            placeholder="Describe an important life skill you have learned..."
                            className="w-full h-full min-h-[200px] bg-transparent border-none resize-none p-4 focus:shadow-none"
                        />
                    </div>
                </div>

                <div className="bg-[#EFF6FF] rounded-lg overflow-hidden border border-blue-200 flex flex-col h-full">
                    <div className="bg-[#BFDBFE] p-3 text-center font-bold text-sm border-b border-blue-200">
                        Experiences at home, school or in the community that helped you develop the skill
                    </div>
                    <div className="p-0 flex-1">
                        <TextArea
                            value={formData.skill_development_experiences}
                            onChange={(e) => handleInputChange('skill_development_experiences', e.target.value)}
                            placeholder="Describe the experiences that helped you develop this skill..."
                            className="w-full h-full min-h-[200px] bg-transparent border-none resize-none p-4 focus:shadow-none"
                        />
                    </div>
                </div>

                {/* Middle Row - Full Width */}
                <div className="col-span-1 md:col-span-2 bg-[#EFF6FF] rounded-lg overflow-hidden border border-blue-200 flex flex-col">
                    <div className="bg-[#BFDBFE] p-3 text-center font-bold text-sm border-b border-blue-200">
                        Why is this skill important to you?
                    </div>
                    <div className="p-0">
                        <TextArea
                            value={formData.why_skill_important}
                            onChange={(e) => handleInputChange('why_skill_important', e.target.value)}
                            placeholder="Explain why this skill is important to you and your future..."
                            className="w-full min-h-[150px] bg-transparent border-none resize-none p-4 focus:shadow-none"
                        />
                    </div>
                </div>

                {/* Bottom Row - Full Width */}
                <div className="col-span-1 md:col-span-2 bg-[#EFF6FF] rounded-lg overflow-hidden border border-blue-200 flex flex-col">
                    <div className="bg-[#BFDBFE] p-3 text-center font-bold text-sm border-b border-blue-200">
                        What is another life skill you would like to develop and why do you think it will be important to you?
                    </div>
                    <div className="p-0">
                        <TextArea
                            value={formData.future_skill_to_develop}
                            onChange={(e) => handleInputChange('future_skill_to_develop', e.target.value)}
                            placeholder="Describe a life skill you want to develop and why it's important..."
                            className="w-full min-h-[150px] bg-transparent border-none resize-none p-4 focus:shadow-none"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartA6SkillsForLife;